document.querySelectorAll('.image-with-text__hover-video').forEach((video) => {
  const container = video.closest('.image-with-text__media');
  if (!container) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const activate = () => {
    container.classList.add('hero-video-active');
    video.play().catch(() => {});
  };

  const deactivate = () => {
    container.classList.remove('hero-video-active');
    video.pause();
  };

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (canHover) {
    const play = () => {
      video.currentTime = 0;
      activate();
    };
    container.addEventListener('mouseenter', play);
    container.addEventListener('mouseleave', deactivate);
    container.addEventListener('focusin', play);
    container.addEventListener('focusout', deactivate);
    return;
  }

  // Touch devices have no hover: autoplay while the hero is in view instead,
  // so it stays a passive, low-cost effect rather than needing a tap prompt.
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activate();
        } else {
          deactivate();
        }
      });
    },
    { threshold: 0.5 }
  );
  observer.observe(container);
});
